import { FC, MouseEvent, useState } from "react";
import { HStack, Skeleton, Text } from "@chakra-ui/react";

import { unleashClient } from "../../../../../../providers";
import { ExclamationMarkIcon, ReloadIcon } from "../../../../../icons";

export const MainPagePaymentScheduleCommissionError: FC = () => {
  const [isPending, setIsPending] = useState<boolean>(false);

  const onClick = async (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    setIsPending(true);

    try {
      await unleashClient.updateToggles();
    } finally {
      setIsPending(false);
    }
  };

  if (isPending) {
    return <Skeleton h="34px" my="5px" />;
  }

  return (
    <HStack
      px="12px"
      py="7px"
      my="5px"
      justifyContent="space-between"
      backgroundColor="red.25"
      borderRadius="12px"
      as="button"
      onClick={onClick}
    >
      <HStack spacing="6px">
        <ExclamationMarkIcon color="red.500" />

        <Text variant="brand" fontSize="12px">
          Не удалось получить комиссию
        </Text>
      </HStack>

      <ReloadIcon color="red.500" />
    </HStack>
  );
};
